export default "__VITE_ASSET__CEL4aNjv__"